export const scrollWithOffset = (el) => {
  const yCoordinate = el.getBoundingClientRect().top + window.pageYOffset;
  const yOffset = -88; // Header height offset
  window.scrollTo({ top: yCoordinate + yOffset, behavior: 'smooth' });
};
